import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

import imagesloaded from 'imagesloaded';

export default () => {
  gsap.registerPlugin(ScrollTrigger);

  cloneBlocks();

  let acticeBlockClass = 'studio-block--active';
  let blocks = document.querySelectorAll('.studio-block');
  let wrappers = document.querySelectorAll('.studio-blocks');

  let isAuto = false;
  let isScrolledToStart = false;

  imagesloaded(blocks, function( instance ) {
    !iOS() && autoScroll();
    blockTitles();
    infiniteScroll();
  });

  function infiniteScroll() {
    let wrapper = wrappers[0];
    let second = wrappers[1];
    document.addEventListener('scroll', (e) => {
      if (second.getBoundingClientRect().top <= 0) {
        window.scrollTo(0, window.scrollY + wrapper.getBoundingClientRect().top + (-1*second.getBoundingClientRect().top));
      }
    });
  }
  function cloneBlocks() {
    let blocks = document.querySelector('.studio-blocks');
    blocks.after(blocks.cloneNode(true))
  }
  function autoScroll() {
    let cursor = document.querySelector('.cursor');

    cursor.classList.add('cursor--load');


    function scr() {
      if (isAuto) {
        window.scrollBy(0, 1);
      }
      window.requestAnimationFrame(scr);
    }

    window.requestAnimationFrame(scr);

    setTimeout(function(){
      isAuto = true;
      cursor.classList.remove('cursor--load');
    }, 3000);

    document.addEventListener('scroll', (e) => {
      if(window.scrollY === 0) {
        isAuto = false;
        isScrolledToStart = true;
        clearBlocks(blocks, acticeBlockClass);
      } 
      else {
        if (isScrolledToStart) {
          isAuto = true;
          isScrolledToStart = false;
        }
      }
    });
  }

  function blockTitles() {
    if (blocks.length) {
      blocks.forEach(function(block) {

        let st = ScrollTrigger.create({
          trigger: block,
          start: "top center",
          end: "bottom center",
          onEnter: self => setActive(blocks, block, acticeBlockClass),
          onEnterBack: self => setActive(blocks, block, acticeBlockClass)
        });
      });
    }
  }
  function setActive(blocks, block, cl) {
    blocks.forEach(function(b) {
      b.classList.remove(cl);
    });
    block.classList.add(cl);
  }
  function clearBlocks(blocks, cl) {
    blocks.forEach(function(b) {
      b.classList.remove(cl);
    });
  }

  function iOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
}
